import { inject, type InjectionKey } from 'vue'

export const injectStrict = <T>(key: string | InjectionKey<T>): T => {
  const value = inject(key)
  if (!value) {
    throw new Error('Injection failed: ' + key.toString())
  }

  return value
}
